__turbopack_context__.v({
  "buttonLink": "styles-module-scss-module__j1IbuG__buttonLink",
  "buttonsContainer": "styles-module-scss-module__j1IbuG__buttonsContainer",
  "description": "styles-module-scss-module__j1IbuG__description",
  "enableButton": "styles-module-scss-module__j1IbuG__enableButton",
  "gpsDeniedDescription": "styles-module-scss-module__j1IbuG__gpsDeniedDescription",
  "gpsDeniedMessage": "styles-module-scss-module__j1IbuG__gpsDeniedMessage",
  "gpsDeniedTitle": "styles-module-scss-module__j1IbuG__gpsDeniedTitle",
  "recheck": "styles-module-scss-module__j1IbuG__recheck",
  "recheckButton": "styles-module-scss-module__j1IbuG__recheckButton",
  "restricted": "styles-module-scss-module__j1IbuG__restricted",
  "title": "styles-module-scss-module__j1IbuG__title",
});
